/* eslint-disable  @typescript-eslint/no-explicit-any */ // AJB: remove
import ListingCard from "@/components/listing/ListingCard";
import AspectSelect from "@/components/search/AspectSelect";
import ListingCarousel from "@/components/shared/ListingCarousel";
import SORT_OPTIONS from "@/constants/SortOptions";
import HomePageSearchRequest from "@/models/HomePageSearchRequest";
import { HomePageSearchResponse } from "@/models/HomePageSearchResponse";
import { Box, Typography } from "@mui/material";

export default function ResultsSection({
  searchResponse,
  searchRequest,
  handleSearchRequestChange,
  featuredResponse,
}: {
  searchResponse: HomePageSearchResponse;
  searchRequest: HomePageSearchRequest;
  handleSearchRequestChange: (updates: any) => void;
  featuredResponse: HomePageSearchResponse;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        paddingBottom: 0,
        position: "relative",
        ".MuiAutocomplete-root": {
          flexShrink: 0,
        },
      }}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 4,
          [theme.breakpoints.down("lg")]: {
            gap: 2,
          },
        })}
      >
        <Box
          sx={(theme) => ({
            [theme.breakpoints.down("sm")]: {
              flexBasis: "100%",
            },
          })}
        >
          <Typography
            component="span"
            variant="h5"
            sx={{ display: "inline", fontWeight: "bold" }}
          >
            {searchResponse?.results.totalResults}
            &nbsp;
          </Typography>
          <Typography variant="h5" component="h1" sx={{ display: "inline" }}>
            {searchResponse.results.title}
          </Typography>
        </Box>
        <Box
          sx={{
            marginLeft: "auto",
          }}
        >
          <AspectSelect
            aspectKey="sort-by"
            aspectLabel="Sort By"
            value={searchRequest.sortBy}
            options={SORT_OPTIONS}
            onValueChange={(sortBy) => handleSearchRequestChange({ sortBy })}
            fullWidth={false}
            size="small"
          />
        </Box>
      </Box>
      {featuredResponse?.results?.totalResults > 0 && (
        <Box
          sx={{
            position: "relative",
          }}
        >
          <ListingCarousel
            title="Featured Ads"
            ads={featuredResponse.results.ads}
            size="small"
            placement="AD_IMPRESSIONS#SEARCH#FEATURED"
          />
        </Box>
      )}
      <Box
        sx={{
          paddingTop: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {featuredResponse?.results?.totalResults > 0 && (
          <Typography variant="h6" component="h2">
            All Results
          </Typography>
        )}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: 4,
          }}
        >
          {searchResponse?.results.ads.map((ad) => (
            <ListingCard key={ad.id} ad={ad} isSearchResult />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
